import React from 'react';
import styled from 'styled-components';
import '@fontsource/montserrat';
import { theme } from '_constants/theme';
const { colors, fontSizes, spaces } = theme;

const StyledRushProduct = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ selected }) => (selected ? '#f04e23' : '#E9EBF4')};
  border-radius: 16px;
  padding: 25px 15px 21px;
  align-items: center;
  flex: 1 1 0;
  gap: 24px;
  .form-check .form-check-input:checked + label {
    font-family: Montserrat;
    font-size: 14px;
    color: #434343;
  }
`;
const StyledProductName = styled.div`
  color: #ff4a00;
  font-family: 'MontserratBold';
  font-weight: 700;
  font-size: 16px;
`;
const StyledProductDescription = styled.div`
  color: black;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 14px;
`;
const StyledPrice = styled.div`
  background-color: ${({ colored }) => (colored ? '#fff4e7' : '')};
  border-radius: 16px;
  color: ${({ colored }) => (colored ? '#ff4a00' : '#7b7b7b')};
  padding: 4px 11px;
  font-size: 16px;
`;
const StyledButton = styled.div`
  font-family: Montserrat;
  font-weight: 600;
  font-size: 12px;
  border: 1px solid #dadde5;
  border-radius: 16px;
  width: 100%;
  text-decoration: none;
  padding: 10px;
  cursor: pointer;
  background: ${({ selected }) => (selected ? '#fff4e7' : '')};
  color: ${({ selected }) => (selected ? '#ff4a00' : '#434343')};
  text-align: center;
`;
export default function RushProduct({
  onChange,
  selected,
  price,
  customerName,
  customerDescription,
  checkboxTitle,
  code,
}) {
  return (
    <StyledRushProduct selected={selected === code}>
      <StyledProductName>{customerName}</StyledProductName>
      <StyledProductDescription>{customerDescription}</StyledProductDescription>
      <StyledPrice colored={price !== 0}>
        {'$' + price?.toFixed(2) + ' USD'}
      </StyledPrice>
      <StyledButton selected={selected === code} onClick={() => onChange(code)}>
        {checkboxTitle}
      </StyledButton>
    </StyledRushProduct>
  );
}
